import styled from "styled-components";
import {
  width,
  space,
  display,
  position,
  maxWidth,
  textAlign,
  boxShadow,
  background,
  alignItems,
  borderRadius,
  flexDirection,
} from "styled-system";

export const Div = styled.div`
  ${width};
  ${space};
  ${display};
  ${position};
  ${maxWidth};
  ${textAlign};
  ${boxShadow};
  ${background};
  ${alignItems};
  ${borderRadius};
  ${flexDirection};
`;
